import { getUrl } from '../config';
import axios from "axios";

const axiosInstance = axios.create();

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    console.log(error)
    // Préserver l'erreur axios originale au lieu de la transformer
    return Promise.reject(error)
  }
);

export default axiosInstance;
